import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import SideMenu from '../shared/sidemenu/SideMenu';
import Loader from '../shared/Loader';
import InboxListItem from '../inbox/InboxListItem';
import * as types from 'misc/types';
import EnvelopeView from './inbox/EnvelopeView';
import { getText, trackGA } from 'misc/helpers';

class Inbox extends Component {
    render = () => {
        const { envelopes_inbox } = this.props;

        return (
            <div className="main-content">
                <SideMenu />
                <article className="list-content fill-parent">
                    <div className="padded-content fill-parent">
                        <Loader objectToLoad={envelopes_inbox}>
                            {envelopes_inbox.isLoaded &&
                                envelopes_inbox.data && (
                                    <React.Fragment>
                                        <h1>{getText('_3_2_IconMailbox', 'Brevlåda')}</h1>
                                        <h2 dangerouslySetInnerHTML={{ __html: this.getNrUnreadEnvelopes() }} />
                                        <ul>
                                            {envelopes_inbox.data.map(envelope => (
                                                <InboxListItem
                                                    view="inbox"
                                                    className={envelope.state.archived ? 'hej' : ''}
                                                    {...envelope}
                                                />
                                            ))}
                                        </ul>
                                    </React.Fragment>
                                )}
                        </Loader>
                    </div>
                </article>
                <aside className="view-content">
                    <Route path="/inbox/:id" component={EnvelopeView} />
                </aside>
            </div>
        );
    };

    getNrUnreadEnvelopes() {
        const { envelopes_inbox } = this.props;

        let nrUnread = 0;

        if (envelopes_inbox.data) {
            envelopes_inbox.data.forEach(function(envelope) {
                if (envelope && !envelope.state.read) {
                    nrUnread++;
                }
            });
        }

        let text = '';

        if (nrUnread > 1) {
            text = getText('_3_0_2TextUnopenedletters', 'Hej, du har {nr} oöppnade brev');
            text = text.replace('{nr}', "<span class='read-marker'>" + nrUnread + '</span>');
        } else if (nrUnread === 1) {
            text = getText('_3_0_2Text UnopenedLetter', 'Hej, du har 1 oöppnat brev');
            text = text.replace('1', "<span class='read-marker'>1</span>");
        } else {
            text = getText('_3_0_1_Textnoletters', 'Hej, du har inga oöppnade brev');
        }

        return text;
    }

    componentDidMount() {
        // Get envelopes
        const { customer, dispatch } = this.props;
        dispatch({ type: types.SAGA_ENVELOPES_INBOX_GET.REQUEST, customer: customer.data, tagged: '_INBOX' });

        trackGA('3.0 Inkorg');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        envelopes_inbox: state.envelopes_inbox,
        sessions: state.sessions,
        customer: state.customer
    };
};

export default connect(mapStateToProps)(Inbox);



// WEBPACK FOOTER //
// ./src/components/views/Inbox.js